import { dropdownMapping } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { regex } from "views/pages/manage/common/constant/regex/index";
import { updateRequest } from "../../../constant/common";
import moment from "moment";

var _ = require("lodash");

export const purchaseTypes = [
  { label: "Capex(PR)", value: "capexPr" },
  { label: "Opex(PR)", value: "opexPr" },
  { label: "Service(PR)", value: "servicePr" },
  { label: "Normal(PR)", value: "normalPr" }
];

export const newRow = {
  Item_no: 0,
  Account_asignment: "",
  Item_cat: "",
  Material_no: "",
  Material_text: "",
  Material_group: "",
  Quantity: "",
  Unit: "",
  Delivery_date: "",
  Plant: "",
  Storage_Location: "",
  Purchase_group: "",
  Requisitioner: "",
  Vendor: "",
  Asset_no: "",
  SubAsset_no: "",
  Telephone_no: "",
  Department: "",
  Email_id: "",
  Business_area: "",
  GL_account: "",
  Cost_Center: "",
  Profit_Center: "",
  Release_group: "",
  Release_strategy: "",
  Release_indicator: "",
  Release_details: ""
};

export const newServiceRow = {
  Item_no: 0,
  SrvLine: "",
  Service_no: "",
  Quantity: "",
  Price: "",
};

export const hardcodeDropdown = {
  Campaign_Name: [
    {
      id: 1,
      label: "RCC-1",
      value: "1",
    },
    {
      id: 2,
      label: "Repeater-2",
      value: "2",
    },
    {
      id: 3,
      label: "ANTHE-3",
      value: "3",
    },
    {
      id: 4,
      label: "JEE Main Session 1-4",
      value: "4",
    },
    {
      id: 5,
      label: "JEE Main Session 2-5",
      value: "5",
    },
    {
      id: 6,
      label: "JEE Advanced-6",
      value: "6",
    },
    {
      id: 7,
      label: "Board Exam - CBSE-10 & 12-7",
      value: "7",
    },
    {
      id: 8,
      label: "State CET Exam Budget-8",
      value: "8",
    },
    {
      id: 9,
      label: "NEET-9",
      value: "9",
    },
    {
      id: 10,
      label: "Teacher Day Activity-10",
      value: "10",
    },
    {
      id: 11,
      label: "Diwali-11",
      value: "11",
    },
    {
      id: 12,
      label: "Christmas Activity-12",
      value: "12",
    },
    {
      id: 13,
      label: "New Year-13",
      value: "13",
    },
    {
      id: 14,
      label: "JEE Main 1 Results-14",
      value: "14",
    },
    {
      id: 15,
      label: "Post-Board print campaign-15",
      value: "15",
    },
    {
      id: 16,
      label: "JEE Main (Session 2) result print campaign-16",
      value: "16",
    },
    {
      id: 17,
      label: "Repeaters Print Ad Campaign after NEET Exam-17",
      value: "17",
    },
    {
      id: 18,
      label: "NEET Results Print campaign-18",
      value: "18",
    },
    {
      id: 19,
      label: "JEE Advanced Results-19",
      value: "19",
    },
    {
      id: 20,
      label: "Walk in Print Campaign (RCC)-20",
      value: "20",
    },
  ],

  Doc_Type: [
    {
      id: 1,
      label: "Framework Requisn-FO",
      value: "FO",
    },
    {
      id: 2,
      label: "Purchase Requisition-NB",
      value: "NB",
    },
    {
      id: 3,
      label: "Outl. Agmt Requisn-RV",
      value: "RV",
    },
    {
      id: 4,
      label: "Digital Serialized-ZDIG",
      value: "ZDIG",
    },
    {
      id: 5,
      label: "JOBWORK PR-ZJOB",
      value: "ZJOB",
    },
    {
      id: 6,
      label: "MANUAL PR-ZMAN",
      value: "ZMAN",
    },
    {
      id: 7,
      label: "MARKETING PR-ZMRK",
      value: "ZMRK",
    },
    {
      id: 8,
      label: "PACKAGES PR-ZPAK",
      value: "ZPAK",
    },
    {
      id: 9,
      label: "SERVICE PR-ZSER",
      value: "ZSER",
    },
    {
      id: 10,
      label: "STOCK TRF REQ-ZSTR",
      value: "ZSTR",
    },
  ],
  Account_asignment: [
    {
      id: 0,
      label: "Standard",
      value: "",
    },
    {
      id: 1,
      label: "Asset-A",
      value: "A",
    },
    // {
    //   id: 2,
    //   label: "MTS prod./sales ord.-B",
    //   value: "B",
    // },
    // {
    //   id: 3,
    //   label: "Sales order-C",
    //   value: "C",
    // },
    // {
    //   id: 4,
    //   label: "Indiv.cust./project-D",
    //   value: "D",
    // },
    // {
    //   id: 5,
    //   label: "Ind. cust. w. KD-CO-E",
    //   value: "E",
    // },
    // {
    //   id: 6,
    //   label: "Order-F",
    //   value: "F",
    // },
    // {
    //   id: 7,
    //   label: "MTS prod./project-G",
    //   value: "G",
    // },
    // {
    //   id: 8,
    //   label: "Nonstock sales-H",
    //   value: "H",
    // },
    {
      id: 9,
      label: "Cost center-K",
      value: "K",
    },
    // {
    //   id: 10,
    //   label: "Ind. cust. w/o KD-CO-M",
    //   value: "M",
    // },
    // {
    //   id: 11,
    //   label: "Network-N",
    //   value: "N",
    // },
    // {
    //   id: 12,
    //   label: "Project-P",
    //   value: "P",
    // },
    // {
    //   id: 13,
    //   label: "Proj. make-to-order-Q",
    //   value: "Q",
    // },
    // {
    //   id: 14,
    //   label: "All new aux.acc.ass.-T",
    //   value: "T",
    // },
    // {
    //   id: 15,
    //   label: "Unknown-U",
    //   value: "U",
    // },
    // {
    //   id: 16,
    //   label: "All aux.acct.assgts.-X",
    //   value: "X",
    // },
    // {
    //   id: 17,
    //   label: "Returnable Packaging-Z",
    //   value: "Z",
    // },
  ],
  Item_cat: [
    {
      id: 1,
      label: "Standard",
      value: "",
    },
    // {
    //   id: 2,
    //   label: "Consignment-K",
    //   value: "K",
    // },
    {
      id: 3,
      label: "Service-D",
      value: "D",
    },
    // {
    //   id: 4,
    //   label: "Subcontracting-L",
    //   value: "L",
    // },
    // {
    //   id: 5,
    //   label: "Material unknown-M",
    //   value: "M",
    // },
    // {
    //   id: 6,
    //   label: "Third-party-S",
    //   value: "S",
    // },
    // {
    //   id: 7,
    //   label: "Text-T",
    //   value: "T",
    // },
    // {
    //   id: 8,
    //   label: "Stock transfer-U",
    //   value: "U",
    // },
    // {
    //   id: 9,
    //   label: "Material group-W",
    //   value: "W",
    // }
  ],
  Purchase_group: [
    {
      id: 1,
      label: "Office & Admin Exp-CMN",
      value: "CMN",
    },
    {
      id: 2,
      label: "Media-COM",
      value: "COM",
    },
    {
      id: 3,
      label: "Content Upgrade-CUP",
      value: "CUP",
    },
    {
      id: 4,
      label: "DIGITAL-DIG",
      value: "DIG",
    },
    {
      id: 5,
      label: "Service Charge-FSC",
      value: "FSC",
    },
    {
      id: 6,
      label: "INFRASTRUCTURE-INF",
      value: "INF",
    },
    {
      id: 7,
      label: "IT & HARDWARE-ITH",
      value: "ITH",
    },
    {
      id: 8,
      label: "Student Courseware-M&C",
      value: "M&C",
    },
    {
      id: 9,
      label: "MARKETING-MRK",
      value: "MRK",
    },
    {
      id: 10,
      label: "Stock Transfer Ord-STO",
      value: "STO",
    },
  ],
  Department: [
    {
      id: 1,
      label: "AAKASH DIGITAI & ITUTOR",
      value: "AAKASH DIGITAI & ITUTOR",
    },
    {
      id: 2,
      label: "BRANCH",
      value: "BRANCH",
    },
    {
      id: 3,
      label: "COMMERCIAL",
      value: "COMMERCIAL",
    },
    {
      id: 4,
      label: "DIGITAL MARKETING",
      value: "DIGITAL MARKETING",
    },
    {
      id: 5,
      label: "FINANCE & ACCOUNTS",
      value: "FINANCE & ACCOUNTS",
    },
    {
      id: 6,
      label: "FRANCHISE",
      value: "FRANCHISE",
    },
    {
      id: 7,
      label: "HO ADMIN",
      value: "HO ADMIN",
    },
    {
      id: 8,
      label: "HR OPERATIONS",
      value: "HR OPERATIONS",
    },
    {
      id: 9,
      label: "HR RECRUITMENT",
      value: "HR RECRUITMENT",
    },
    {
      id: 10,
      label: "INFRA",
      value: "INFRA",
    },
    {
      id: 11,
      label: "IT",
      value: "IT",
    },
    {
      id: 12,
      label: "MARKETING",
      value: "MARKETING",
    },
    {
      id: 13,
      label: "MEDIA",
      value: "MEDIA",
    },
    {
      id: 14,
      label: "OPERATIONS",
      value: "OPERATIONS",
    },
    {
      id: 15,
      label: "TAXATION",
      value: "TAXATION",
    },
    {
      id: 16,
      label: "TRAINING",
      value: "TRAINING",
    },
  ],
  serviceFilter: [
    {
      id: 0,
      label: "yes",
      value: "X"
    },
    {
      id: 1,
      label: "no",
      value: ""
    },
  ],
  additionalPlant: [
    {
      id: 0,
      label: "HO01",
      value: "HO01"
    },
    {
      id: 2,
      label: "HO07",
      value: "HO07"
    },
  ]
};

export const areAllMandatoryFieldsFilled = (rowForm, requiredFields = []) => {
  if (_.isEmpty(rowForm)) return false;

  return requiredFields.every((field) => {
    const value = _.get(rowForm, field, null);
    if (field === "Material_no") {
      return !_.isEmpty(_.get(value, "value", "")?.trim());
    }
    if (_.isObject(value)) {
      return (
        !_.isEmpty(_.get(value, "value", "")?.trim()) ||
        !_.isEmpty(_.get(value, "id", ""))
      );
    }
    return !_.isEmpty(_.trim(value));
  });
};

export const getDropdowns = async () => {
  try {
    const resp = await Promise.all([
      dropdownMapping(
        endpoint.businessArea.getAllActiveV2,
        "sapBusinessArea",
        "sapPlantId"
      ),
    ]);
    return {
      allActiveBu: resp[0],
    };
  } catch (err) {
    console.error(err);
  }
};

export const authCredentials = {
  username: "POCAMPUS",
  password: "Welcome@123",
};

export const authHeader = `Basic ${btoa(
  `${authCredentials?.username}:${authCredentials?.password}`
)}`;


export const sapendpoint = {
  // create: "http://172.16.1.122:50000/RESTAdapter/CreatePR",
  // search: "http://172.16.1.122:50000/RESTAdapter/DisplayPR"
  create: "https://phoenixapi-qa.aakash.ac.in/api/enrollmentService/sapMasters/createPr",
  search: "https://phoenixapi-qa.aakash.ac.in/api/enrollmentService/sapMasters/getDisplayPr"
};

export const actionType = ["C", "U", "D"];

/**
 * 
 * function to handle single vs multiple items 
 * same function used for create, update and delete
 */

export const createReqObj = (header, purchaseOrder = [], purchaseType, actionType = "C", prNo, fileData) => {
  const { Campaign_Name, Doc_Type, Text, Telephone_no, Department, Email_id } = header;
  const purchaseOrders = Array.isArray(purchaseOrder) ? purchaseOrder : [purchaseOrder];

  const reqObj = {
    Header: {
      Text: Text || "",
      Campaign_Name: typeof Campaign_Name === "object" ? (Campaign_Name?.value || "") : Campaign_Name,
      Doc_Type: typeof Doc_Type === "object" ? (Doc_Type?.value || "") : Doc_Type,
      Action_ind: actionType,
      PR_no: prNo || '',
      Attachment: fileData?.attachment || "",
      attachmentName: fileData?.fileName || "",
      attachmentExtension: fileData?.fileExtension || ""
    },
    Item: purchaseOrders.map((po) => {
      const itemObj = {
        Item_no: po.Item_no?.toString() || "",
        Material_no: po.Material_no?.value || "",
        Material_text: po.Material_text || "",
        Account_asignment: po.Account_asignment?.value || "",
        Item_cat: po.Item_cat?.value || "",
        Quantity: po.Quantity || "",
        Unit: po.Unit || "",
        Delivery_date: po?.Delivery_date ? moment(po?.Delivery_date)?.format("DD.MM.YYYY") : "",
        Material_group: po.Material_group || "",
        Plant: po.Plant?.value || "",
        Storage_Location: po.Storage_Location || "",
        Purchase_group: po.Purchase_group?.value || "",
        Requisitioner: po.Requisitioner || "",
        Vendor: po.Vendor?.value || "",
        Asset_no: typeof po.Asset_no === "object" ? po.Asset_no?.value || "" : po.Asset_no || "",
        SubAsset_no: po.SubAsset_no || "",
        Business_area: po.Business_area || "",
        GL_account: po.GL_account || "",
        Profit_Center: po.Profit_Center || "",
        Cost_Center: po.Cost_Center?.value || "",
        Telephone_no: Telephone_no || "",
        Department: Department?.value || "",
        Email_id: Email_id || "",
        Delete_ind: po?.Delete_ind || "",
      };
      // if (po?.Delete_ind) {
      //   itemObj.Delete_ind = po?.Delete_ind
      // }
      // if (undelete) {
      //   itemObj.Delete_ind = "";
      // }
      // If the purchaseType is "servicePr", nest service items inside each Item
      if (purchaseType === "servicePr") {
        const services = Array.isArray(po?.Service_Item) ? po.Service_Item : po.Service_Item ? [po.Service_Item] : [];
        itemObj.Service_Item = services.map(({ SrvLine, Item_no, Service_no, Quantity, Price, Cost_Center }) => ({
          SrvLine: SrvLine?.toString() || "",
          Item_no: Item_no?.toString() || "", // Ensure the Item_no matches the parent
          Service_no: Service_no?.value || "",
          Quantity: Quantity || "",
          Price: Price || "",
          Cost_Center: Cost_Center?.value || "",
        }));
      }

      return itemObj;
    }),
  };

  return reqObj;
};

export const labelStyles = {
  fontSize: "12px",
  marginTop: "4px",
};

export const initialFilter = {
  PrNo: '',
  AccountAssignment: '',
  ItemText: '',
  Services: '',
  ServiceText: '',
  Plant: '',
  Material: '',
  Doc_Type: '',
  DateHigh: '',
  DateLow: '',
  Vendor: ''
}


export const findLabelByValue = (val, key) => {
  const obj = hardcodeDropdown?.[key].find(item => item?.value == val)
  return obj?.label
}

export const hasNumber = (text) => {
  const regex = /\b(?:requisition|doc(?:ument)?) number\s+\d+\b/i;
  return regex.test(text);
};